
// app/i18n/translation-update.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { firstValueFrom } from 'rxjs';
import { getStoredVersion, isRemoteNewer, storeDictionary } from './translation-storage';

interface VersionResponse {
  version: string;
}

interface DictionaryResponse {
  _meta?: { version: string };
  [key: string]: any; // traduções
}

function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

@Injectable({ providedIn: 'root' })
export class TranslationUpdateService {
  // Ajuste para sua API
  private readonly apiBase = `${environment.config.apiUrlItek}/api/i18n`;

  constructor(private http: HttpClient) {}

  /**
   * Checa versão remota e atualiza IndexedDB se houver dicionário mais novo.
   * Não deve quebrar o bootstrap se a API estiver offline.
   */
  async ensureLatest(lang: string): Promise<void> {
    if (!isBrowser()) return; // em SSR, pule
    try {
      const localVersion = await getStoredVersion(lang);
      const remote = await firstValueFrom(
        this.http.get<VersionResponse>(`${this.apiBase}/${lang}/_meta`)
      );

      if (remote?.version && isRemoteNewer(localVersion, remote.version)) {
        const dict = await firstValueFrom(
          this.http.get<DictionaryResponse>(`${this.apiBase}/${lang}`)
        );
        const version = dict?._meta?.version ?? remote.version ?? '0';
        const { _meta, ...translations } = dict ?? {};
        await storeDictionary(lang, version, translations);
      }
    } catch {
      // Silencioso: offline/erro de rede
    }
  }
}
